import { reverseGeocodeLocation } from "../actions/checkoutStore";

export function GeolocationUtils(
  dispatch,
  url,
  position,
  country,
  region,
  municipality,
  shipping,
) {
  const params = {
    position: position,
    country: country,
    region: region,
    municipality: municipality,
    shipping: shipping,
  };
  dispatch(reverseGeocodeLocation(url, params));
}
